
// ************************************************************************************ Corrected

// import React, { useState, useMemo } from 'react';
// import {
//   Box,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Avatar,
//   Typography,
//   Divider,
//   useTheme,
//   Collapse,
//   IconButton,
//   Drawer,
//   Tooltip,
//   Menu,
//   MenuItem,
// } from '@mui/material';
// import MenuOpenIcon from '@mui/icons-material/MenuOpen';
// import { NavLink, useNavigate } from 'react-router-dom';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import CloseIcon from '@mui/icons-material/Close';
// import { adminSideNavbarRoutes, cpSideNavbarRoutes, sideNavbarRoutes } from '../../AppRoutes/routePaths';
// import { buildMenu } from '../../AppRoutes/utils';
// import { RoutePathProps } from '../../AppRoutes/types';
// import { useResponsive } from '../../utils/useResponsive';

// // Define layout types
// export type LayoutType = 'default' | 'admin' | 'controlPanel';

// // Add interface for props
// interface SidebarProps {
//   mobileOpen?: boolean;
//   onMobileClose?: () => void;
//   collapsed?: boolean;
//   onToggleCollapse?: () => void;
//   layoutType?: LayoutType; // Add layout type prop
// }

// const Sidebar: React.FC<SidebarProps> = ({ 
//   mobileOpen = false, 
//   onMobileClose = () => {}, 
//   collapsed = false,
//   onToggleCollapse = () => {},
//   layoutType = 'default' // Default to default layout
// }) => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const { isDesktop } = useResponsive();

//   // Determine which routes to use based on layoutType prop
//   const sideNavMenu = useMemo(() => {
//     switch (layoutType) {
//       case 'admin':
//         return adminSideNavbarRoutes;
//       case 'controlPanel':
//         return cpSideNavbarRoutes;
//       default:
//         return sideNavbarRoutes;
//     }
//   }, [layoutType]);

//   const menu = useMemo(() => buildMenu(sideNavMenu), [sideNavMenu]);

//   const handleBrandClick = () => {
//     navigate('/');
//     if (!isDesktop) onMobileClose();
//   }

//   const sidebarWidth = collapsed ? 70 : 250;

//   // Drawer content for mobile/tablet
//   const drawerContent = (
//     <Box
//       sx={{
//         width: 250,
//         bgcolor: theme.palette.background.paper,
//         display: 'flex',
//         flexDirection: 'column',
//         p: 1,
//         borderRadius: 1.5,
//       }}
//     >
//       {/* Drawer Header with Close Button (mobile/tablet only) */}
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center', 
//         mb: 2, 
//         px: 1,
//         pt: 1 
//       }}>
//         <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={handleBrandClick}>
//           <Avatar
//             src="https://static.vecteezy.com/system/resources/previews/048/771/791/non_2x/elegant-hexagon-letter-jd-logo-design-initial-luxurious-jd-logo-template-vector.jpg"
//             alt="Brand Logo"
//             sx={{ mr: 1, cursor: "pointer" }}
//           >
//             JD
//           </Avatar>
//           {!collapsed && (
//             <Typography variant="h5" fontWeight={700} color={theme.palette.primary.main} sx={{cursor:"pointer"}}>
//               JD-SI
//             </Typography>
//           )}
//         </Box>
//         {/* Close button for mobile/tablet */}
//         <IconButton
//           onClick={onMobileClose}
//           sx={{ 
//             display: { xs: 'flex', md: 'none' },
//             color: theme.palette.text.secondary
//           }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </Box>

//       <Divider sx={{ mb: 2, mx: 1 }} />
//       <SideNavbarList menu={menu} onItemClick={onMobileClose} collapsed={collapsed} />
//     </Box>
//   );

//   // Desktop View - Permanent Sidebar
//   if (isDesktop) {
//     return (
//       <Box
//         sx={{
//           width: sidebarWidth,
//           minHeight: '100vh',
//           bgcolor: theme.palette.background.paper,
//           position: 'sticky',
//           top: 0,
//           left: 0,
//           zIndex: 1100,
//           display: 'flex',
//           flexDirection: 'column',
//           p: 1,
//           borderRadius: 1.2,
//           mt: 8,
//           transition: theme => theme.transitions.create(['width'], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen,
//           }),
//           overflow: 'hidden',
//         }}
//       >
//         {/* Desktop Header */}
//         <Box sx={{ 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'space-between',
//           mb: 2, 
//           px: 1 ,
//           position:'relative'
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={handleBrandClick}>
//             <Avatar
//               src="https://static.vecteezy.com/system/resources/previews/048/771/791/non_2x/elegant-hexagon-letter-jd-logo-design-initial-luxurious-jd-logo-template-vector.jpg"
//               alt="Brand Logo"
//               sx={{ 
//                 mr: collapsed ? 0 : 1, 
//                 cursor: "pointer",
//                 transition: 'margin 0.2s ease'
//               }}
//             >
//               JD
//             </Avatar>
//             {!collapsed && (
//               <Typography 
//                 variant="h5" 
//                 fontWeight={700} 
//                 color={theme.palette.primary.main} 
//                 sx={{
//                   cursor:"pointer",
//                   whiteSpace: 'nowrap',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis'
//                 }}
//               >
//                 JD-SI
//               </Typography>
//             )}
//           </Box>

//           {/* Toggle Button - Shows Collapse when expanded, Expand when collapsed */}
//           {isDesktop && (
//             <Tooltip title={collapsed ? "Expand Sidebar" : "Collapse Sidebar"} placement='top' arrow>
//               <IconButton
//                 onClick={onToggleCollapse}
//                 size="small"
//                 sx={{
//                   color: theme.palette.text.secondary,
//                   position:'absolute',
//                   right:-10,
//                   bottom:-33,
//                   zIndex:20,
//                   '&:hover': {
//                     backgroundColor: theme.palette.action.hover,
//                   }
//                 }}
//               >
//                 {collapsed ? <ChevronRightIcon /> : <MenuOpenIcon />}
//               </IconButton>
//             </Tooltip>
//           )}
//         </Box>

//         <Divider sx={{ mb: 2, mx: 1 }} />
//         <SideNavbarList 
//           menu={menu} 
//           collapsed={collapsed} 
//           onToggleCollapse={onToggleCollapse}
//           level={0}
//         />
//       </Box>
//     );
//   }

//   // Mobile/Tablet View - Drawer
//   return (
//     <Drawer
//       variant="temporary"
//       open={mobileOpen}
//       onClose={onMobileClose}
//       ModalProps={{
//         keepMounted: true,
//       }}
//       sx={{
//         display: { xs: 'block', md: 'none' },
//         '& .MuiDrawer-paper': {
//           boxSizing: 'border-box',
//           width: 250,
//           borderTopRightRadius: 12,
//           borderBottomRightRadius: 12,
//         },
//       }}
//     >
//       {drawerContent}
//     </Drawer>
//   );
// };

// export default Sidebar;

// // NavMenuItem component remains exactly the same as your original
// interface NavMenuItemProps {
//   item: RoutePathProps;
//   isOpen?: boolean;
//   onClick?: () => void;
//   onItemClick?: () => void;
//   collapsed?: boolean;
//   level?: number;
// }

// const NavMenuItem: React.FC<NavMenuItemProps> = ({ 
//   item, 
//   isOpen, 
//   onClick, 
//   onItemClick, 
//   collapsed = false,
//   level = 0
// }) => {
//   const theme = useTheme();
//   const { isDesktop } = useResponsive();
//   const navigate = useNavigate();
//   const Icon = item.icon as React.ElementType | undefined;
//   const isDummy = item.dummy || false;
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [nestedAnchorEl, setNestedAnchorEl] = useState<null | HTMLElement>(null);
//   const [nestedMenuParent, setNestedMenuParent] = useState<RoutePathProps | null>(null);

//   const hasChildren = item?.children && item.children.length > 0;

//   const handleClick = (e: React.MouseEvent<HTMLElement>) => {
//     if (collapsed && hasChildren) {
//       // When collapsed and has children, show popup menu
//       e.preventDefault();
//       e.stopPropagation();
//       setAnchorEl(e.currentTarget);
//     } else if (isDummy) {
//       e.preventDefault();
//       e.stopPropagation();
//       if (onClick) onClick();
//     } else {
//       if (!isDesktop && onItemClick) {
//         onItemClick();
//       }
//     }
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setNestedAnchorEl(null);
//     setNestedMenuParent(null);
//   };

//   const handleMenuItemClick = (childItem: RoutePathProps) => {
//     if (childItem?.children && childItem.children.length > 0) {
//       // If child has children, show nested menu
//       setNestedMenuParent(childItem);
//       setNestedAnchorEl(anchorEl);
//     } else {
//       // If no children, navigate
//       handleMenuClose();
//       navigate(childItem.path);
//       if (!isDesktop && onItemClick) {
//         onItemClick();
//       }
//     }
//   };

//   const handleNestedMenuClose = () => {
//     setNestedAnchorEl(null);
//     setNestedMenuParent(null);
//   };

//   const handleNestedMenuItemClick = (nestedItem: RoutePathProps) => {
//     handleMenuClose();
//     navigate(nestedItem.path);
//     if (!isDesktop && onItemClick) {
//       onItemClick();
//     }
//   };

//   // Recursive function to render nested menus
//   const renderNestedMenu = (parentItem: RoutePathProps, depth: number = 0) => {
//     if (!parentItem?.children || parentItem.children.length === 0) return null;

//     return (
//       <Menu
//         key={`nested-${parentItem.name}-${depth}`}
//         anchorEl={nestedAnchorEl}
//         open={Boolean(nestedAnchorEl) && nestedMenuParent?.name === parentItem.name}
//         onClose={handleNestedMenuClose}
//         anchorOrigin={{
//           vertical: 'top',
//           horizontal: 'right',
//         }}
//         transformOrigin={{
//           vertical: 'top',
//           horizontal: 'left',
//         }}
//         PaperProps={{
//           sx: {
//             mt: -1,
//             ml: 1,
//             minWidth: 200,
//             maxWidth: 300,
//             maxHeight: 400,
//             overflow: 'auto',
//             boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
//             borderRadius: 2,
//           }
//         }}
//       >
//         <Box sx={{ px: 1.5, py: 1, backgroundColor: theme.palette.grey[50] }}>
//           <Typography variant="subtitle2" fontWeight={600} color="text.primary">
//             {parentItem.label}
//           </Typography>
//         </Box>
//         <Divider />
//         {parentItem.children.map((child) => {
//           const childHasChildren = child?.children && child.children.length > 0;
//           const ChildIcon = child.icon as React.ElementType | undefined;

//           return (
//             <MenuItem
//               key={child.name}
//               onClick={() => childHasChildren ? handleMenuItemClick(child) : handleNestedMenuItemClick(child)}
//               sx={{
//                 py: 1,
//                 px: 2,
//                 borderRadius: 1,
//                 position: 'relative',
//                 '&:hover': {
//                   backgroundColor: theme.palette.action.hover,
//                 }
//               }}
//             >
//               {ChildIcon && (
//                 <ListItemIcon sx={{ minWidth: 36 }}>
//                   <ChildIcon />
//                 </ListItemIcon>
//               )}
//               <ListItemText 
//                 primary={child.label}
//                 sx={{
//                   '& .MuiTypography-root': {
//                     fontSize: '0.875rem',
//                   }
//                 }}
//               />
//               {childHasChildren && (
//                 <ChevronRightIcon 
//                   sx={{ 
//                     fontSize: 16, 
//                     color: 'text.secondary',
//                     ml: 1
//                   }} 
//                 />
//               )}
//             </MenuItem>
//           );
//         })}
//       </Menu>
//     );
//   };

//   return (
//     <>
//       <Tooltip 
//         title={collapsed ? item.label : ""} 
//         placement="right"
//         arrow
//       >
//         <ListItem
//           key={item.name}
//           component={hasChildren && collapsed ? 'div' : NavLink}
//           to={!collapsed || !hasChildren ? item.path : '#'}
//           end={item.path === '/'}
//           onClick={handleClick}
//           sx={{
//             px: 1,
//             py: 0.75,
//             mb: 0.5,
//             color: '#5C607B',
//             borderRadius: 2,
//             justifyContent: collapsed ? 'center' : 'flex-start',
//             cursor: 'pointer',
//             backgroundColor: level > 0 ? theme.palette.grey[50] : 'transparent',
//             '&:hover': {
//               backgroundColor: theme.palette.action.hover,
//               '& .MuiListItemText-root': {
//                 color: theme.palette.primary.light,
//               },
//             },
//             '& .MuiListItemIcon-root': {
//               color: 'inherit',
//               minWidth: collapsed ? 'auto' : 'auto',
//               marginRight: collapsed ? 0 : 1,
//               justifyContent: 'center',
//               ml: collapsed ? 0 : level * 2,
//             },
//             '&.active': {
//               color: theme.palette.primary.main,
//               fontWeight: 700,
//               '& .MuiListItemIcon-root': {
//                 color: theme.palette.primary.main,
//               },
//               '& .MuiListItemText-root': {
//                 color: theme.palette.primary.main,
//               },
//             },
//           }}
//         >
//           <ListItemIcon>
//             {Icon ? <Icon /> : null}
//           </ListItemIcon>
//           {!collapsed && (
//             <>
//               <ListItemText 
//                 primary={item.label} 
//                 sx={{
//                   '& .MuiTypography-root': {
//                     fontSize: '0.875rem',
//                     fontWeight: 500,
//                     whiteSpace: 'nowrap',
//                     overflow: 'hidden',
//                     textOverflow: 'ellipsis',
//                   }
//                 }}
//               />
//               {hasChildren && (
//                 <IconButton 
//                   size="small" 
//                   edge="end" 
//                   color='inherit' 
//                   aria-label="toggle"
//                   sx={{ 
//                     opacity: isDummy ? 1 : 0,
//                     transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
//                     transition: 'transform 200ms'
//                   }}
//                 >
//                   <ChevronRightIcon />
//                 </IconButton>
//               )}
//             </>
//           )}
//         </ListItem>
//       </Tooltip>

//       {/* First level popup menu for collapsed sidebar */}
//       {collapsed && hasChildren && item.children && (
//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleMenuClose}
//           anchorOrigin={{
//             vertical: 'top',
//             horizontal: 'right',
//           }}
//           transformOrigin={{
//             vertical: 'top',
//             horizontal: 'left',
//           }}
//           PaperProps={{
//             sx: {
//               mt: -1,
//               ml: 1,
//               minWidth: 200,
//               maxWidth: 300,
//               maxHeight: 400,
//               overflow: 'auto',
//               boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
//               borderRadius: 2,
//             }
//           }}
//         >
//           <Box sx={{ px: 1.5, py: 1, backgroundColor: theme.palette.grey[50] }}>
//             <Typography variant="subtitle2" fontWeight={600} color="text.primary">
//               {item.label}
//             </Typography>
//           </Box>
//           <Divider />
//           {item.children.map((child) => {
//             const childHasChildren = child?.children && child.children.length > 0;
//             const ChildIcon = child.icon as React.ElementType | undefined;

//             return (
//               <MenuItem
//                 key={child.name}
//                 onClick={() => handleMenuItemClick(child)}
//                 sx={{
//                   py: 1,
//                   px: 2,
//                   borderRadius: 1,
//                   position: 'relative',
//                   '&:hover': {
//                     backgroundColor: theme.palette.action.hover,
//                   }
//                 }}
//               >
//                 {ChildIcon && (
//                   <ListItemIcon sx={{ minWidth: 36 }}>
//                     <ChildIcon />
//                   </ListItemIcon>
//                 )}
//                 <ListItemText 
//                   primary={child.label}
//                   sx={{
//                     '& .MuiTypography-root': {
//                       fontSize: '0.875rem',
//                     }
//                   }}
//                 />
//                 {childHasChildren && (
//                   <ChevronRightIcon 
//                     sx={{ 
//                       fontSize: 16, 
//                       color: 'text.secondary',
//                       ml: 1
//                     }} 
//                   />
//                 )}
//               </MenuItem>
//             );
//           })}
//         </Menu>
//       )}

//       {/* Render nested menu if there's a parent with children */}
//       {collapsed && nestedMenuParent && renderNestedMenu(nestedMenuParent)}
//     </>
//   );
// }

// // SideNavbarList component remains exactly the same as your original
// interface SideNavbarListProps {
//   menu: RoutePathProps[];
//   onItemClick?: () => void;
//   collapsed?: boolean;
//   onToggleCollapse?: () => void;
//   level?: number;
// }

// const SideNavbarList: React.FC<SideNavbarListProps> = ({ 
//   menu, 
//   onItemClick, 
//   collapsed = false,
//   onToggleCollapse = () => {},
//   level = 0
// }) => {
//   const [openMap, setOpenMap] = useState<Record<string, boolean>>({});

//   const toggle = (name: string) => {
//     setOpenMap((s) => ({ ...s, [name]: !s[name] }));
//   };

//   return (
//     <List sx={{ overflow: 'hidden', flex: 1 }}>
//       {menu?.map((item) => {
//         const isOpen = openMap[item.name] || false;
//         const hasChildren = item?.children && item.children.length > 0;

//         return (
//           <React.Fragment key={item.name}>
//             <NavMenuItem
//               item={item}
//               onClick={() => toggle(item.name)}
//               onItemClick={onItemClick}
//               isOpen={isOpen}
//               collapsed={collapsed}
//               level={level}
//             />
//             {!collapsed && hasChildren && (
//               <Collapse in={isOpen} timeout="auto" unmountOnExit>
//                 <SideNavbarList 
//                   menu={item.children ?? []} 
//                   onItemClick={onItemClick} 
//                   collapsed={collapsed}
//                   onToggleCollapse={onToggleCollapse}
//                   level={level + 1}
//                 />
//               </Collapse>
//             )}
//           </React.Fragment>
//         );
//       })}
//     </List>
//   );
// };



// *************************************************************************  With Permission Access
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Typography,
  Divider,
  useTheme,
  Collapse,
  IconButton,
  Drawer,
  Tooltip,
  Menu,
  MenuItem,
} from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { NavLink, useNavigate } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import { adminSideNavbarRoutes, cpSideNavbarRoutes, sideNavbarRoutes } from '../../AppRoutes/routePaths';
import { buildMenu } from '../../AppRoutes/utils';
import { RoutePathProps } from '../../AppRoutes/types';
import { useResponsive } from '../../utils/useResponsive';
import { useAuth } from '../../contexts/AuthContext';
import { request } from '../../utils/request';
import { baseUrlImage } from '../../utils/apiClient';
import { BusinessInfo } from '../../modules/controlPanel/types';
import { toast } from 'react-toastify';

// Define layout types
export type LayoutType = 'default' | 'admin' | 'controlPanel';

// Add interface for props
interface SidebarProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
  layoutType?: LayoutType;
}

const Sidebar: React.FC<SidebarProps> = ({
  mobileOpen = false,
  onMobileClose = () => { },
  collapsed = false,
  onToggleCollapse = () => { },
  layoutType = 'default'
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { isDesktop } = useResponsive();
  const { hasPermission } = useAuth();

  const [businessInfo, setBusinessInfo] = useState<BusinessInfo>();

  const fetchBusinessInfo = useCallback(async () => {
    try {
      const res = await request({
        url: "setting/businessInfo",
        method: "get",
      });

      if (res.success) {
        setBusinessInfo(res.data);
      }
    } catch (err: any) {
      console.error(err);

      toast.error(err.message || "Failed to fetch business info");
    }
  }, []);
  useEffect(() => {
    fetchBusinessInfo();
  }, [fetchBusinessInfo])


  // Filter routes based on permissions
  const filterRoutesByPermissions = useCallback((routesArray: RoutePathProps[]): RoutePathProps[] => {
    return routesArray.filter(route => {
      // If route has requiredPermission, check if user has it
      if (route.requiredPermission && !hasPermission(route.requiredPermission)) {
        return false;
      }

      // Recursively filter children
      if (route.children && route.children.length > 0) {
        route.children = filterRoutesByPermissions(route.children);
        // Only keep route if it has visible children
        return route.children.length > 0;
      }

      return true;
    });
  }, [hasPermission]);

  // Determine which routes to use based on layoutType prop
  const sideNavMenu = useMemo(() => {
    let routes;
    switch (layoutType) {
      case 'admin':
        routes = adminSideNavbarRoutes;
        break;
      case 'controlPanel':
        routes = cpSideNavbarRoutes;
        break;
      default:
        routes = sideNavbarRoutes;
    }

    // Filter routes based on permissions
    return filterRoutesByPermissions(routes);
  }, [layoutType, filterRoutesByPermissions]);

  const menu = useMemo(() => buildMenu(sideNavMenu), [sideNavMenu]);

  const handleBrandClick = () => {
    navigate('/');
    if (!isDesktop) onMobileClose();
  }

  const sidebarWidth = collapsed ? 70 : 250;

  // Drawer content for mobile/tablet
  const drawerContent = (
    <Box
      sx={{
        width: 250,
        bgcolor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        p: 1,
        borderRadius: 1.5,
      }}
    >
      {/* Drawer Header with Close Button (mobile/tablet only) */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        px: 1,
        pt: 1
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={handleBrandClick}>
          <Avatar
            // src="https://static.vecteezy.com/system/resources/previews/048/771/791/non_2x/elegant-hexagon-letter-jd-logo-design-initial-luxurious-jd-logo-template-vector.jpg"
            src={baseUrlImage + businessInfo?.businessLogo}
            alt="Brand Logo"
            sx={{ mr: 1, cursor: "pointer" }}
          >
            JD
          </Avatar>
          {!collapsed && (
            <Typography variant="h5" fontWeight={700} color={theme.palette.primary.main} sx={{ cursor: "pointer" }}>
              {businessInfo?.businessName}
            </Typography>
          )}
        </Box>
        {/* Close button for mobile/tablet */}
        <IconButton
          onClick={onMobileClose}
          sx={{
            display: { xs: 'flex', md: 'none' },
            color: theme.palette.text.secondary
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider sx={{ mb: 2, mx: 1 }} />
      <SideNavbarList
        menu={menu}
        onItemClick={onMobileClose}
        collapsed={collapsed}
        hasPermission={hasPermission}
      />
    </Box>
  );

  // Desktop View - Permanent Sidebar
  if (isDesktop) {
    return (
      <Box
        sx={{
          width: sidebarWidth,
          minHeight: '100vh',
          bgcolor: theme.palette.background.paper,
          position: 'sticky',
          top: 0,
          left: 0,
          zIndex: 1100,
          display: 'flex',
          flexDirection: 'column',
          p: 1,
          borderRadius: 1.2,
          mt: 8,
          transition: theme => theme.transitions.create(['width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          overflow: 'hidden',
        }}
      >
        {/* Desktop Header */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
          px: 1,
          position: 'relative'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={handleBrandClick}>
            <Avatar
              // src="https://static.vecteezy.com/system/resources/previews/048/771/791/non_2x/elegant-hexagon-letter-jd-logo-design-initial-luxurious-jd-logo-template-vector.jpg"
              src={baseUrlImage + businessInfo?.businessLogo}
              alt="Brand Logo"
              sx={{
                mr: collapsed ? 0 : 1,
                cursor: "pointer",
                transition: 'margin 0.2s ease'
              }}
            >
              JD
            </Avatar>
            {!collapsed && (
              <Tooltip title={businessInfo?.businessName || 'JD-SI'} arrow placement="top">
                <Typography
                  variant="h5"
                  fontWeight={700}
                  color={theme.palette.primary.main}
                  sx={{
                    cursor: "pointer",
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '160px',
                  }}
                >
                  {businessInfo?.businessName || 'JD-SI'}
                </Typography>
              </Tooltip>
            )}
          </Box>

          {/* Toggle Button - Shows Collapse when expanded, Expand when collapsed */}
          {isDesktop && (
            <Tooltip title={collapsed ? "Expand Sidebar" : "Collapse Sidebar"} placement='top' arrow>
              <IconButton
                onClick={onToggleCollapse}
                size="small"
                sx={{
                  color: theme.palette.text.secondary,
                  position: 'absolute',
                  right: -10,
                  bottom: -33,
                  zIndex: 20,
                  '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                  }
                }}
              >
                {collapsed ? <ChevronRightIcon /> : <MenuOpenIcon />}
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Divider sx={{ mb: 2, mx: 1 }} />
        <SideNavbarList
          menu={menu}
          collapsed={collapsed}
          onToggleCollapse={onToggleCollapse}
          level={0}
          hasPermission={hasPermission}
        />
      </Box>
    );
  }

  // Mobile/Tablet View - Drawer
  return (
    <Drawer
      variant="temporary"
      open={mobileOpen}
      onClose={onMobileClose}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        display: { xs: 'block', md: 'none' },
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: 250,
          borderTopRightRadius: 12,
          borderBottomRightRadius: 12,
        },
      }}
    >
      {drawerContent}
    </Drawer>
  );
};

export default Sidebar;

// NavMenuItem component with permission filtering for children
interface NavMenuItemProps {
  item: RoutePathProps;
  isOpen?: boolean;
  onClick?: () => void;
  onItemClick?: () => void;
  collapsed?: boolean;
  level?: number;
  hasPermission?: (permission: string) => boolean;
}

const NavMenuItem: React.FC<NavMenuItemProps> = ({
  item,
  isOpen,
  onClick,
  onItemClick,
  collapsed = false,
  level = 0,
  hasPermission = () => true
}) => {
  const theme = useTheme();
  const { isDesktop } = useResponsive();
  const navigate = useNavigate();
  const Icon = item.icon as React.ElementType | undefined;
  const isDummy = item.dummy || false;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [nestedAnchorEl, setNestedAnchorEl] = useState<null | HTMLElement>(null);
  const [nestedMenuParent, setNestedMenuParent] = useState<RoutePathProps | null>(null);

  // Filter children based on permissions
  const filteredChildren = useMemo(() => {
    if (!item.children) return [];
    return item.children.filter(child => {
      if (child.requiredPermission && !hasPermission(child.requiredPermission)) {
        return false;
      }
      return true;
    });
  }, [item.children, hasPermission]);

  const hasChildren = filteredChildren.length > 0;

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (collapsed && hasChildren) {
      // When collapsed and has children, show popup menu
      e.preventDefault();
      e.stopPropagation();
      setAnchorEl(e.currentTarget);
    } else if (isDummy) {
      e.preventDefault();
      e.stopPropagation();
      if (onClick) onClick();
    } else {
      if (!isDesktop && onItemClick) {
        onItemClick();
      }
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setNestedAnchorEl(null);
    setNestedMenuParent(null);
  };

  const handleMenuItemClick = (childItem: RoutePathProps) => {
    if (childItem?.children && childItem.children.length > 0) {
      // If child has children, show nested menu
      setNestedMenuParent(childItem);
      setNestedAnchorEl(anchorEl);
    } else {
      // If no children, navigate
      handleMenuClose();
      navigate(childItem.path);
      if (!isDesktop && onItemClick) {
        onItemClick();
      }
    }
  };

  const handleNestedMenuClose = () => {
    setNestedAnchorEl(null);
    setNestedMenuParent(null);
  };

  const handleNestedMenuItemClick = (nestedItem: RoutePathProps) => {
    handleMenuClose();
    navigate(nestedItem.path);
    if (!isDesktop && onItemClick) {
      onItemClick();
    }
  };

  // Recursive function to render nested menus
  const renderNestedMenu = (parentItem: RoutePathProps, depth: number = 0) => {
    if (!parentItem?.children || parentItem.children.length === 0) return null;

    // Filter children based on permissions
    const filteredParentChildren = parentItem.children.filter(child => {
      if (child.requiredPermission && !hasPermission(child.requiredPermission)) {
        return false;
      }
      return true;
    });

    if (filteredParentChildren.length === 0) return null;

    return (
      <Menu
        key={`nested-${parentItem.name}-${depth}`}
        anchorEl={nestedAnchorEl}
        open={Boolean(nestedAnchorEl) && nestedMenuParent?.name === parentItem.name}
        onClose={handleNestedMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            mt: -1,
            ml: 1,
            minWidth: 200,
            maxWidth: 300,
            maxHeight: 400,
            overflow: 'auto',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            borderRadius: 1,
          }
        }}
      >
        <Box sx={{ px: 1.5, py: 1, backgroundColor: theme.palette.grey[50] }}>
          <Typography variant="subtitle2" fontWeight={600} color="text.primary">
            {parentItem.label}
          </Typography>
        </Box>
        <Divider />
        {filteredParentChildren.map((child) => {
          const childHasChildren = child?.children && child.children.length > 0;
          const ChildIcon = child.icon as React.ElementType | undefined;

          return (
            <MenuItem
              key={child.name}
              onClick={() => childHasChildren ? handleMenuItemClick(child) : handleNestedMenuItemClick(child)}
              sx={{
                py: 1,
                px: 2,
                borderRadius: 1,
                position: 'relative',
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                }
              }}
            >
              {ChildIcon && (
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <ChildIcon />
                </ListItemIcon>
              )}
              <ListItemText
                primary={child.label}
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '0.875rem',
                  }
                }}
              />
              {childHasChildren && (
                <ChevronRightIcon
                  sx={{
                    fontSize: 16,
                    color: 'text.secondary',
                    ml: 1
                  }}
                />
              )}
            </MenuItem>
          );
        })}
      </Menu>
    );
  };

  return (
    <>
      <Tooltip
        title={collapsed ? item.label : ""}
        placement="right"
        arrow
      >
        <ListItem
          key={item.name}
          component={hasChildren && collapsed ? 'div' : NavLink}
          to={!collapsed || !hasChildren ? item.path : '#'}
          end={item.path === '/'}
          onClick={handleClick}
          sx={{
            px: 1,
            py: 0.75,
            mb: 0.5,
            color: '#5C607B',
            borderRadius: 1,
            justifyContent: collapsed ? 'center' : 'flex-start',
            cursor: 'pointer',
            backgroundColor: level > 0 ? theme.palette.grey[50] : 'transparent',
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
              '& .MuiListItemText-root': {
                color: theme.palette.primary.light,
              },
            },
            '& .MuiListItemIcon-root': {
              color: 'inherit',
              minWidth: collapsed ? 'auto' : 'auto',
              marginRight: collapsed ? 0 : 1,
              justifyContent: 'center',
              ml: collapsed ? 0 : level * 2,
            },
            '&.active': {
              color: theme.palette.primary.main,
              fontWeight: 700,
              '& .MuiListItemIcon-root': {
                color: theme.palette.primary.main,
              },
              '& .MuiListItemText-root': {
                color: theme.palette.primary.main,
              },
            },
          }}
        >
          <ListItemIcon>
            {Icon ? <Icon /> : null}
          </ListItemIcon>
          {!collapsed && (
            <>
              <ListItemText
                primary={item.label}
                sx={{
                  '& .MuiTypography-root': {
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }
                }}
              />
              {hasChildren && (
                <IconButton
                  size="small"
                  edge="end"
                  color='inherit'
                  aria-label="toggle"
                  sx={{
                    opacity: isDummy ? 1 : 0,
                    transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: 'transform 200ms'
                  }}
                >
                  <ChevronRightIcon />
                </IconButton>
              )}
            </>
          )}
        </ListItem>
      </Tooltip>

      {/* First level popup menu for collapsed sidebar */}
      {collapsed && hasChildren && filteredChildren.length > 0 && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            sx: {
              mt: -1,
              ml: 1,
              minWidth: 200,
              maxWidth: 300,
              maxHeight: 400,
              overflow: 'auto',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              borderRadius: 1,
            }
          }}
        >
          <Box sx={{ px: 1.5, py: 1, backgroundColor: theme.palette.grey[50] }}>
            <Typography variant="subtitle2" fontWeight={600} color="text.primary">
              {item.label}
            </Typography>
          </Box>
          <Divider />
          {filteredChildren.map((child) => {
            const childHasChildren = child?.children && child.children.length > 0;
            const ChildIcon = child.icon as React.ElementType | undefined;

            return (
              <MenuItem
                key={child.name}
                onClick={() => handleMenuItemClick(child)}
                sx={{
                  py: 1,
                  px: 2,
                  borderRadius: 1,
                  position: 'relative',
                  '&:hover': {
                    backgroundColor: theme.palette.action.hover,
                  }
                }}
              >
                {ChildIcon && (
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <ChildIcon />
                  </ListItemIcon>
                )}
                <ListItemText
                  primary={child.label}
                  sx={{
                    '& .MuiTypography-root': {
                      fontSize: '0.875rem',
                    }
                  }}
                />
                {childHasChildren && (
                  <ChevronRightIcon
                    sx={{
                      fontSize: 16,
                      color: 'text.secondary',
                      ml: 1
                    }}
                  />
                )}
              </MenuItem>
            );
          })}
        </Menu>
      )}

      {/* Render nested menu if there's a parent with children */}
      {collapsed && nestedMenuParent && renderNestedMenu(nestedMenuParent)}
    </>
  );
}

// SideNavbarList component with permission support
interface SideNavbarListProps {
  menu: RoutePathProps[];
  onItemClick?: () => void;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
  level?: number;
  hasPermission?: (permission: string) => boolean;
}

const SideNavbarList: React.FC<SideNavbarListProps> = ({
  menu,
  onItemClick,
  collapsed = false,
  onToggleCollapse = () => { },
  level = 0,
  hasPermission = () => true
}) => {
  const [openMap, setOpenMap] = useState<Record<string, boolean>>({});

  const toggle = (name: string) => {
    setOpenMap((s) => ({ ...s, [name]: !s[name] }));
  };

  return (
    <List sx={{ overflow: 'hidden', flex: 1 }}>
      {menu?.map((item) => {
        const isOpen = openMap[item.name] || false;
        const hasChildren = item?.children && item.children.length > 0;

        return (
          <React.Fragment key={item.name}>
            <NavMenuItem
              item={item}
              onClick={() => toggle(item.name)}
              onItemClick={onItemClick}
              isOpen={isOpen}
              collapsed={collapsed}
              level={level}
              hasPermission={hasPermission}
            />
            {!collapsed && hasChildren && (
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <SideNavbarList
                  menu={item.children ?? []}
                  onItemClick={onItemClick}
                  collapsed={collapsed}
                  onToggleCollapse={onToggleCollapse}
                  level={level + 1}
                  hasPermission={hasPermission}
                />
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
    </List>
  );
};